import Image from "./../image";

interface ImageButtonProps {
  src: string;
  onClick: (e?: any) => void;
  alt: string;
  size: number;
  className?: string;
}

const ImageButton: React.FC<ImageButtonProps> = ({
  src,
  onClick,
  alt,
  size,
  className
}) => {
  return (
    <button onClick={(e) => onClick(e)} className={className}>
      <Image aria-hidden src={src} alt={alt} width={size} height={size} />
    </button>
  );
};

export default ImageButton;
